import { message } from "antd";

let messageApiInstance = null;

export const setMessageInstance = (instance) => {
  messageApiInstance = instance;
};

export const showToast = {
  success: (content) => {
    if (messageApiInstance) {
      messageApiInstance.success(content);
    }
  },
  error: (content) => {
    if (messageApiInstance) {
      messageApiInstance.error(content);
    }
  },
  warning: (content) => {
    if (messageApiInstance) {
      messageApiInstance.warning(content);
    }
  },
};
